export default "__VITE_ASSET__CEdxmfNT__"